/**
 * Shared scroll-direction watcher for sticky bars (collection toolbar,
 * geschenke pill nav — adopted in later phases). The header keeps its own
 * exact-port handler in header.js.
 *
 * Dylys.watchScrollDirection(function ({ y, up, down }) { ... })
 * Passive listener; direction changes at any delta (the 10px threshold rule
 * is applied by each consumer, matching its source component).
 */
(function () {
  'use strict';

  window.Dylys = window.Dylys || {};

  window.Dylys.watchScrollDirection = function (callback) {
    var lastY = window.scrollY;
    window.addEventListener(
      'scroll',
      function () {
        var y = window.scrollY;
        callback({ y: y, up: y < lastY, down: y > lastY, lastY: lastY });
        lastY = y;
      },
      { passive: true }
    );
  };
})();
